import React from 'react';
import { LayoutDashboardIcon, BotIcon, UsersIcon, ShieldCheckIcon, TrendingUpIcon, MessageCircleIcon, AlertTriangleIcon, HeartHandshakeIcon } from 'lucide-react';
export function ProductSection() {
  return <section className="w-full bg-[#f8f8f8] py-16 md:py-24 border-t border-gray-200" data-id="element-345">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-346">
        <div className="text-center mb-16" data-id="element-347">
          <h2 className="text-[1.625rem] md:text-[2.5rem] font-semibold text-[#111111] leading-[1.2] mb-6" data-id="element-348">
            One place to get it done — and keep it done
          </h2>
          <p className="text-base md:text-lg text-gray-500 leading-relaxed max-w-3xl mx-auto" data-id="element-349">
            No more juggling apps, Googling fixes, or explaining the same thing
            twice. Caveo brings it all together.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 mb-16" data-id="element-350">
          {/* Family Dashboard */}
          <div className="bg-white rounded-2xl p-8 border-2 border-gray-200" data-id="element-351">
            <div className="flex items-center mb-6" data-id="element-352">
              <div className="w-12 h-12 bg-[#631bb7] bg-opacity-5 rounded-xl flex items-center justify-center border border-[#631bb7] border-opacity-10 mr-4" data-id="element-353">
                <LayoutDashboardIcon className="w-6 h-6 text-[#631bb7]" data-id="element-354" />
              </div>
              <h3 className="text-xl md:text-[1.75rem] font-semibold text-[#111111] leading-[1.3]" data-id="element-355">
                See Your Whole Family's Safety at a Glance
              </h3>
            </div>
            <p className="text-base text-gray-600 mb-6 leading-relaxed" data-id="element-356">
              One dashboard shows you where every family member stands and what
              still needs to get done — so no one falls through the cracks.
            </p>
            <div className="space-y-4" data-id="element-357">
              <div className="flex items-start" data-id="element-358">
                <ShieldCheckIcon className="w-5 h-5 text-[#631bb7] mr-3 mt-0.5 flex-shrink-0" data-id="element-359" />
                <div data-id="element-360">
                  <span className="font-semibold text-[#111111]" data-id="element-361">
                    Coordinate protection across your whole household — without
                    becoming everyone's tech support.
                  </span>
                </div>
              </div>
            </div>
          </div>

          {/* AI Security Coach */}
          <div className="bg-white rounded-2xl p-8 border-2 border-gray-200" data-id="element-362">
            <div className="flex items-center mb-6" data-id="element-363">
              <div className="w-12 h-12 bg-[#631bb7] bg-opacity-5 rounded-xl flex items-center justify-center border border-[#631bb7] border-opacity-10 mr-4" data-id="element-364">
                <BotIcon className="w-6 h-6 text-[#631bb7]" data-id="element-365" />
              </div>
              <h3 className="text-xl md:text-[1.75rem] font-semibold text-[#111111] leading-[1.3]" data-id="element-366">
                Guidance That Feels Like a Patient Friend
              </h3>
            </div>
            <p className="text-base text-gray-600 mb-6 leading-relaxed" data-id="element-367">
              Plain-English guidance that walks you through the right actions —
              and flags issues before they become problems.
            </p>
            <div className="space-y-4" data-id="element-368">
              <div className="flex items-start" data-id="element-369">
                <HeartHandshakeIcon className="w-5 h-5 text-[#631bb7] mr-3 mt-0.5 flex-shrink-0" data-id="element-370" />
                <div data-id="element-371">
                  <span className="font-semibold text-[#111111]" data-id="element-372">
                    When you need a real person, we're here too.
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Learning Center Preview */}
        <div className="bg-white rounded-2xl p-8 border-2 border-gray-200" data-id="element-373">
          <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-8" data-id="element-374">
            <div data-id="element-375">
              <h3 className="text-xl md:text-[1.75rem] font-semibold text-[#111111] leading-[1.3] mb-2" data-id="element-376">
                39 guided actions. Built for real families.
              </h3>
              <p className="text-base text-gray-600" data-id="element-377">
                Caveo covers the critical things most families never get around
                to — from securing your passwords to protecting financial
                accounts to planning for the unexpected. Every guide is a
                step-by-step walkthrough, not a lecture.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}